(function ($) {

    if ($('.page-template-page_futureforhealth-collections').length || $('.page-template-page_futureforhealth-leadin').length) {

        $(document).ready(function () {

            var $collections_description = $('.collections-description');
            $collections_description.on('afterChange', function (event, slick, direction) {
                MovePolygon($('.collections-list .collection.active'));
            });

            $collections_description.slick({
                fade: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                swipe: false,
                responsive: [
                    {
                        breakpoint: 700,
                        settings: {
                            adaptiveHeight: true
                        }
                    }
                ]
            });

            var $collections_list = $('.collections-list');
            $collections_list.on('init', function (event, slick, direction) {
                $('.collections-list .collection.slick-current').addClass('active');
            }).on('afterChange', function (event, slick, direction) {
                MovePolygon($('.collections-list .collection.active'));
                if ($(window).width() < 701) {
                    $('.collections-list .collection.slick-active').click();
                }
            });

            $collections_list.slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                infinite: false,
                swipe: false,
                responsive: [
                    {
                        breakpoint: 1060,
                        settings: {
                            slidesToShow: 4,
                            arrows: true
                        }
                    },
                    {
                        breakpoint: 900,
                        settings: {
                            slidesToShow: 3,
                            arrows: true
                        }
                    },
                    {
                        breakpoint: 700,
                        settings: {
                            slidesToShow: 1,
                            arrows: true
                        }
                    }
                ]
            });

            $('.collections-list .collection:not(.active)').live("click", function () {
                fog($(this));
                MovePolygon($(this));

                var ajaxurl = ajaxMeta.ajaxurl,
                    $container = $('.sub_collections-list'),
                    term_id = $(this).data('term_id'),
                    descr = $('.collections-description .descr[data-term_id="' + term_id + '"]').index();

                $('.collections-description').slick('slickGoTo', descr);

                $.ajax({
                    url: ajaxurl,
                    type: 'post',
                    data: {
                        action: 'load_sub_collection',
                        'term_id': term_id
                    },
                    success: function (data) {
                        var $data = $(data);

                        $('.future_for_health-posts .container').empty();
                        $('.collections-block').removeClass('clip-path');
                        if ($data.length) {
                            $container.empty().append($data).find('.sub_collection, .choose').fadeIn('slow');
                        } else {
                            $container.find('.sub_collection, .choose').animate({opacity: 0.0}, 500, setInvisble);

                            function setInvisble() {
                                $container.find('.sub_collection').css('visibility', 'hidden');
                            }
                        }
                    }
                });


                $('.collections-list .collection').removeClass('active');
                $(this).addClass('active');

                return false;
            });

            $('.sub_collections-list .sub_collection:not(.active)').live("click", function () {
                $('.sub_collections-list .sub_collection').removeClass('active');
                $(this).addClass('active');
                fog($(this));

                var ajaxurl = ajaxMeta.ajaxurl,
                    $container = $('.future_for_health-posts .container'),
                    term_id = $(this).data('term_id'),
                    color = $(this).data('color');
                $.ajax({
                    url: ajaxurl,
                    type: 'post',
                    data: {
                        action: 'load_FutureForHealth_posts',
                        'term_id': term_id,
                        'color': color
                    },
                    success: function (data) {
                        $('.collections-block').addClass('clip-path');

                        var $data = $(data);

                        if ($data.length) {
                            $container.empty().append($data).find('.post').fadeIn('slow');
                        } else {
                            $container.empty().html('<div class="nothing-found" style="color:' + color + '">Nothing found</div>');
                            console.log('error');
                        }
                    }
                });
                return false;
            });


            $('.future_for_health-posts .single-post .goback button').live("click", function () {

                var ajaxurl = ajaxMeta.ajaxurl,
                    $container = $('.future_for_health-posts .container'),
                    active = $('.sub_collections-list .sub_collection.active'),
                    term_id = active.data('term_id'),
                    color = active.data('color');
                $.ajax({
                    url: ajaxurl,
                    type: 'post',
                    data: {
                        action: 'load_FutureForHealth_posts',
                        'term_id': term_id,
                        'color': color
                    },
                    success: function (data) {
                        $('.collections-block').addClass('clip-path');

                        var $data = $(data);

                        if ($data.length) {
                            $container.empty().append($data).find('.post').fadeIn('slow');
                        } else {
                            $container.empty().html('<div class="nothing-found" style="color:' + color + '">Nothing found</div>');
                            console.log('error');
                        }
                    }
                });
                return false;
            });


            $('.future_for_health-posts .post').live("click", function () {
                var ajaxurl = ajaxMeta.ajaxurl,
                    $container = $('.future_for_health-posts .container'),
                    post_id = $(this).data('post_id'),
                    color = $(this).data('color');
                $.ajax({
                    url: ajaxurl,
                    type: 'post',
                    data: {
                        action: 'load_post',
                        'post_id': post_id,
                        'color': color
                    },
                    success: function (data) {
                        var $data = $(data);

                        if ($data.length) {
                            $container.empty().append($data).find('.single-post').fadeIn('slow');

                            loadDisqus();

                            window.vc_js();

                            setTimeout(function () {
                                $(window).trigger('resize');
                            }, 1000);

                            var Identifier = $('.single-post').data('post-identifier');
                            var Url = $('.single-post').data('post-url');
                            var Title = $('.single-post').data('post-title');

                            setTimeout(function () {
                                resetDisqus(Identifier, Url, Title);
                            }, 1000);

                            addthis.toolbox('.addthis_toolbox');

                        } else {
                            console.log('error');
                        }
                    }
                });
                return false;
            });

        });


        $(window).on('resize load', function () {
            MovePolygon($('.collections-list .collection.active'));
        });


        function MovePolygon($this) {
            var top = $('.collections-nav').outerHeight(),
                left = ($this.offset().left + ($this.outerWidth() / 2)).toFixed(0);
            $('.collections-nav-path').css({'-webkit-clip-path': 'polygon(0 0, 100% 0, 100% calc(100% - 30px), ' + (left - 30) + 'px calc(100% - 30px), ' + (left) + 'px 100%, calc(' + (left) + 'px + 30px) calc(100% - 30px), 0 calc(100% - 30px))'});
            $('.collections-nav-path').height($('.collections-nav').height());
        }

        function fog($this) {
            var $color = $this.data('color');
            $('.fog').fadeOut(150);
            setTimeout(function () {
                $('.fog').css('background', 'linear-gradient(to bottom, rgba(255,255,255,0) 0%, ' + $color + ' 65%,' + $color + ' 100%)').fadeIn('slow');
            }, 150);
        }

        function loadDisqus() {
            /* * * CONFIGURATION VARIABLES: EDIT BEFORE PASTING INTO YOUR WEBPAGE * * */
            var disqus_shortname = countVars.disqusShortname;

            /* * * DON'T EDIT BELOW THIS LINE * * */
            (function () {
                var dsq = document.createElement('script');
                dsq.type = 'text/javascript';
                dsq.async = true;
                dsq.id = "dsq_js";
                dsq.src = 'https://' + disqus_shortname + '.disqus.com/embed.js';
                (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(dsq);
            })();
        }

        function resetDisqus(newIdentifier, newUrl, newTitle) {
            //console.log(newIdentifier, newUrl, newTitle);

            if (typeof DISQUS != 'undefined') {
                DISQUS.reset({
                    reload: true,
                    config: function () {
                        this.page.identifier = newIdentifier;
                        this.page.url = newUrl;
                        this.page.title = newTitle;
                    }
                });
            } else {
                $('#disqus_thread').live('load', function () {
                    DISQUS.reset({
                        reload: true,
                        config: function () {
                            this.page.identifier = newIdentifier;
                            this.page.url = newUrl;
                            this.page.title = newTitle;
                        }
                    });
                });
            }
        }

    }

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/collections-nav.es6